import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/v1/";

let axiosConfig = {
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  }

};

const login = (username,password) =>{
    return axios.post(API_URL+"login",{username,password}, axiosConfig)
}

export default login;